import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { DataService } from '../services/dataService';
import { SiteConfig } from '../types';

const About: React.FC = () => {
  const { language, t } = useLanguage();
  const [config, setConfig] = useState<SiteConfig>(DataService.getConfig());

  useEffect(() => {
    const handler = (e: any) => {
      try {
        const db = e?.detail?.db || DataService.getDB();
        if (db && db.config) setConfig(db.config);
      } catch {}
    };
    window.addEventListener('db_updated', handler as EventListener);
    try {
      const db = DataService.getDB();
      if (db && db.config) setConfig(db.config);
    } catch {}
    return () => window.removeEventListener('db_updated', handler as EventListener);
  }, []);

  return (
    <div className="relative py-12 bg-temple-orange-50/50">
      <img
        src="/images/t5.jpeg"
        alt=""
        onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
      />
      <div className="relative container mx-auto px-4 max-w-4xl z-10">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-temple-orange-900 mb-8 text-center">
          {language === 'en' ? (config.aboutTitle || 'History & Significance') : (config.aboutTitleMal || 'ചരിത്രവും പ്രാധാന്യവും')}
        </h1>
        
        <div className="bg-white/90 p-8 md:p-12 rounded-2xl shadow-sm border border-orange-100">
          <p className="text-gray-700 leading-relaxed mb-6">
            {language === 'en' ? (config.aboutContent || '') : (config.aboutContentMal || config.aboutContent || '')}
          </p>
          
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-8 mb-4">{t('The Legend', 'ഐതീഹ്യം')}</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            {t(
              'Arunoottimangalam! Once upon a time, there were 600 noble Hindu houses in the area, and there was a great temple that flourished with nationalism! The temple, which had been in a state of disrepair for many years due to the passage of time, was rebuilt and consecrated in the way it is seen today in 2004. The Ashtamangala Devaprasna conducted before the construction of the temple revealed that this temple was a great temple centuries ago and that it may have been destroyed by wars or natural disasters over time. This temple, which has become a refuge for devotees, has become a refuge for many people from different parts of Kerala, recognizing this temple as their family temple in times of trouble and making offerings to solve their problems and carrying out construction work as their dedication. The Arunoottimangalam Bhagavathy Temple stands as a refuge and blessing for those who rely on it.',
              'അറുനൂറ്റിമംഗലം ! ഒരുകാലത്ത് 600 ശ്രേഷ്ഠ ഹിന്ദു ഭവനങ്ങൾ ഉണ്ടായിരുന്ന പ്രദേശം, അവിടെ ദേശാധിപത്യത്തോടെ നിലനിന്നിരുന്ന ഒരു മഹാക്ഷേത്രം ! കാലത്തിൻറെ കുത്തൊഴുക്കിൽ നാമാവശേഷമായി കാലങ്ങളോളം ജീർണാവസ്ഥയിൽ ആയിരുന്ന ക്ഷേത്രത്തെ ഇന്നു കാണുന്ന രീതിയിൽ പുനർ നിർമ്മിച്ചു പ്രതിഷ്ഠ നടത്തിയത് 2004 ൽ ആണ്. ഈ ക്ഷേത്രം നൂറ്റാണ്ടുകൾക്ക് മുമ്പ് ഒരു മഹാക്ഷേത്രം ആയിരുന്നു എന്നും കാലാന്തരത്തിൽ യുദ്ധകലാപങ്ങളാലോ പ്രകൃതിക്ഷോഭത്താലോ നാശം സംഭവിച്ചിരിക്കാം എന്നും ആണ് ക്ഷേത്രനിർമ്മാണത്തിന് മുൻപ് നടത്തിയ അഷ്ടമംഗല ദേവപ്രശ്നത്തിൽ തെളിഞ്ഞത്.ഭക്തജനങ്ങളുടെ അഭയ കേന്ദ്രമായി മാറിക്കഴിഞ്ഞ ഈ ക്ഷേത്രത്തിൽ കേരളത്തിൻറെ പലസ്ഥലങ്ങളിൽ നിന്നും ധാരാളം ആളുകൾ പ്രശ്നവിധിയിൽ തങ്ങളുടെ കുടുംബ ക്ഷേത്രം ഈ ക്ഷേത്രം ആണെന്ന് തിരിച്ചറിഞ്ഞ് പ്രശ്നപരിഹാരാർത്ഥം വഴിപാടുകൾ നടത്തുകയും അവരുടെ സമർപ്പണമായി നിർമ്മാണ പ്രവർത്തനങ്ങൾ നടത്തുകയും ചെയ്തിട്ടുണ്ട് ആശ്രയിക്കുന്നവർക്ക് അഭയ വരദായിനിയായി അറുനൂറ്റിമംഗലം ഭഗവതി ക്ഷേത്രം നിലകൊള്ളുന്നു'
            )}
          </p>
          
                   

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-8 mb-4">{t('Festivals', 'ഉത്സവം')}</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            {t(
              "The annual festival of the installation is celebrated on the days of Punartham, Pooyam and Ayilyam in the month of Meenam. Ancient ritual art forms such as Mudiyettu and Garudan Thukkam are performed every year in connection with the festival. Other important special days are Vishu, Navratri and Mandalavilakku.",
              " പ്രതിഷ്ഠാ വാർഷിക മഹോത്സവം മീനമാസത്തിലെ പുണർതം, പൂയം, ആയില്യം നാളുകളിലാണ് കൊണ്ടാടുന്നത്. പ്രാചീന അനുഷ്ഠാനക കലാരൂപങ്ങളായ മുടിയേറ്റും ഗരുഡൻ തൂക്കവും എല്ലാവർഷവും ഉത്സവത്തോടനുബന്ധിച്ച് നടത്തിവരുന്നു.വിഷു, നവരാത്രി, മണ്ഡലവിളക്ക് എന്നിവയാണ് മറ്റ് പ്രധാന വിശേഷദിവസങ്ങൾ."
               )}
          </p>
          
        
        </div>
      </div>
    </div>
  );
};

export default About;
